import { getTranslate } from 'legacy-src/utilities/i18n'
import Markdown from 'markdown-to-jsx'
import React from 'react'

import { cn } from '@/legacy-src/lib/utils'

import { useCancellationWindowHours } from '@/src/domains/events/hooks/useCancellationWindowHours'

import useFlags from '../hooks/useFlags'
import useIsAppWebView from '../hooks/useIsAppWebView'
import Icon from './icons/Icon'

export enum BenefitsVisibleCount {
  TWO = '2',
  FOUR = '4',
}

interface BenefitItem {
  icon: string | undefined
  textKey: string | TemplateStringsArray
}

interface TherapistCalendarBenefitsProps {
  noOfBenefits?: BenefitsVisibleCount
}

const TherapistCalendarBenefits: React.FC<TherapistCalendarBenefitsProps> = ({ noOfBenefits = '4' }) => {
  const { t } = getTranslate()
  const { showMoneyBackGuarantee } = useFlags()
  const { cancellationWindowHours } = useCancellationWindowHours()

  const isWebView = useIsAppWebView()

  const itemsMap: Record<BenefitsVisibleCount, Array<BenefitItem>> = {
    [BenefitsVisibleCount.TWO]: [
      {
        textKey: 'component.discountModal.cancelReservationWindow',
        icon: 'clock-rebrand',
      },
      {
        textKey: 'component.therapistCalendarOverview.savings',
        icon: 'savings-rebrand',
      },
    ],
    [BenefitsVisibleCount.FOUR]: [
      {
        textKey: 'component.discountModal.cancelReservationWindow',
        icon: 'clock-rebrand',
      },
      ...(showMoneyBackGuarantee
        ? [
            {
              textKey: 'component.therapistCalendarOverview.savings',
              icon: 'savings-rebrand',
            },
          ]
        : []),
      {
        textKey: 'component.therapistCalendarOverview.paidWithCard',
        icon: 'card-rebrand',
      },
      ...(!isWebView
        ? [
            {
              textKey: 'component.therapistCalendarOverview.browser',
              icon: 'computer',
            },
          ]
        : []),
    ],
  }

  const items = itemsMap[noOfBenefits]

  return (
    <div className="mb-8 flex flex-wrap gap-8 tablet:flex-nowrap">
      {items.map((item: BenefitItem, index: React.Key) => (
        <div
          className={cn('basis-full', {
            'tablet:basis-1/2': items.length === 2,
            'tablet:basis-1/3': items.length === 3,
            'tablet:basis-1/4': items.length === 4,
          })}
          key={index}
        >
          <div className="flex gap-4">
            <Icon color="secondary" icon={item.icon} size="md" />
            <Markdown className="text-base">{t(item.textKey, { hours: cancellationWindowHours })}</Markdown>
          </div>
        </div>
      ))}
    </div>
  )
}

export default TherapistCalendarBenefits
